var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.isPC ? 'bottom-quick-order-line' : ''
  }, [_c('div', {
    class: ['bottom-quick-order-container', _vm.isPC && 'bottom-quick-order-container-pc']
  }, [_c('div', {
    on: {
      "click": _vm.closeOrder
    }
  }, [_c('Icon', {
    staticClass: "close-icon",
    attrs: {
      "file": _vm.cardToolbarCloseIcon,
      "width": "12px",
      "height": "12px"
    }
  })], 1), _vm._l(_vm.topCustomField, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "quick-order-custom-field"
    }, [_c('div', {
      staticClass: "custom-field-line"
    }, [item.name ? _c('div', {
      staticClass: "order-name"
    }, [_vm._v(" " + _vm._s(item.name) + ": ")]) : _vm._e(), _c('div', {
      staticClass: "order-value"
    }, [_vm._v(" " + _vm._s(item.value) + " ")])])]);
  }), _c('div', {
    staticClass: "quick-order-main"
  }, [_vm.props.bottomQuickOrder.pic ? _c('img', {
    staticClass: "quick-order-img",
    attrs: {
      "src": _vm.props.bottomQuickOrder.pic
    }
  }) : _vm._e(), _c('div', {
    staticClass: "quick-order-information"
  }, [_c('div', {
    staticClass: "quick-order-title"
  }, [_vm._v(" " + _vm._s(_vm.props.bottomQuickOrder.header) + " ")]), _c('div', {
    staticClass: "quick-order-description-block"
  }, [_c('div', {
    staticClass: "quick-order-description"
  }, [_vm._v(" " + _vm._s(_vm.props.bottomQuickOrder.desc) + " ")]), _vm.bottomCustomField.length === 0 ? _c('div', {
    staticClass: "quick-order-link",
    on: {
      "click": _vm.sendOrder
    }
  }, [_vm._v(" " + _vm._s(_vm.TUITranslateService.t("发送")) + " ")]) : _vm._e()])])]), _vm._l(_vm.bottomCustomField, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "quick-order-custom-field"
    }, [_c('div', {
      staticClass: "custom-field-line"
    }, [item.name ? _c('div', {
      staticClass: "order-name"
    }, [_vm._v(" " + _vm._s(item.name) + ": ")]) : _vm._e(), _c('div', {
      staticClass: "order-value"
    }, [_vm._v(" " + _vm._s(item.value) + " ")])])]);
  }), _vm.bottomCustomField.length !== 0 ? _c('div', {
    staticClass: "quick-order-link",
    on: {
      "click": _vm.sendOrder
    }
  }, [_vm._v(" " + _vm._s(_vm.TUITranslateService.t("发送")) + " ")]) : _vm._e()], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }